import {createAction, createSlice} from '@reduxjs/toolkit';

export interface IZhoTransferPosition {
  userId: number;
  sapCode: string;
  firstName: string;
  middleName: string | null;
  lastName: string;
  staffPositionId: number;
  wsfaCode: string;
}

export interface IZhoOrderTransferItem {
  id: number;
  requestId: number;
  stockistId: string;
  status: string;
  createdByPositionId: number;
  createdByRoleType: number;
  createdOn: string | null;
  updatedOn: string | null;
  sapOrderNo: string | null;
  orderFormNo: string | null;
}

export interface IZhoRequestTransferItem {
  id: number;
  requestFormNo: string;
  partyId: number;
  status: string;
  mrstaffPositionId: number;
  createdByPositionId: number;
  expiryOn: string;
  createdOn: string | null;
  updatedOn: string | null;
}

export const zhoTransferInitialState = {
  fromPosition: null as IZhoTransferPosition | null,
  toPosition: null as IZhoTransferPosition | null,
  orders: [] as IZhoOrderTransferItem[],
  requests: [] as IZhoRequestTransferItem[],
  executeTransferResponse: null as {success: boolean; message: string} | null,
  hasResults: false,
  isTransferring: false,
};

export const executeZhoTransferCreator = createAction<any>(
  'ZHO_TRANSFER_HANDLER/EXECUTE_TRANSFER',
);
export const executeZhoTransferCreatorTypeName =
  executeZhoTransferCreator(null).type;

const zhoTransferStateHandler = createSlice({
  name: 'ZHO_TRANSFER_HANDLER',
  initialState: zhoTransferInitialState,
  reducers: {
    setZhoTransferListData: (prevState, action) => {
      return {
        ...prevState,
        fromPosition: action.payload?.fromPosition ?? null,
        toPosition: action.payload?.toPosition ?? null,
        orders: action.payload?.orders ?? [],
        requests: action.payload?.requests ?? [],
        hasResults: true,
      };
    },
    setExecuteTransferResponse: (prevState, action) => {
      return {
        ...prevState,
        executeTransferResponse: action.payload,
      };
    },
    setIsTransferring: (prevState, action) => {
      return {
        ...prevState,
        isTransferring: action.payload,
      };
    },
    setHasResults: (prevState, action) => {
      return {
        ...prevState,
        hasResults: action.payload,
      };
    },
    resetZhoTransferState: () => zhoTransferInitialState,
  },
});

export const zhoTransferStateActions = zhoTransferStateHandler.actions;
export const zhoTransferStateReducer = zhoTransferStateHandler.reducer;
